import { useDroppable } from "@dnd-kit/core";
import { ReactNode } from "react";

// DroppableColumnWrapper.tsx
export default function DroppableColumnWrapper({
  id,
  children,
}: {
  id: string;
  children: ReactNode;
}) {
  const { setNodeRef, isOver } = useDroppable({ id });
  return (
    <div
      ref={setNodeRef}
      className={`flex-1 min-h-[300px] my-5 p-2 rounded-md transition-colors ${isOver ? "bg-gray-200" : "bg-gray-100"
        }`}
    >
      {children}
    </div>
  );
}

